module.exports = __webpack_public_path__ + "media/images/sa-sidebar-ad1d1c8e1ea094953a91e148fc6f4005.png";